import { isLogin } from '@/api';
export default {
  data() {
    return {
      transitionName: 'slide-right',
      // 默认动态路由变化为slide-right
      include: ['addOrder']
    };
  },
  watch: {
    '$route'(to, from) {
      if (to.meta.index > from.meta.index) {
        // 比较大小使用不同翻页动画
        this.transitionName = 'slide-left';
      } else if (to.meta.index < from.meta.index) {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = 'slide';
      }
      this.watchRoute(to);
    }
  },
  created() {},
  mounted() {
    this.noMovingUp();
  },
  methods: {
    watchRoute(to) {
      const vm = this;
      if (to.meta.needLogin) {
        // 校验是否登录
        vm.checkLogin();
      }
      document.title = to.meta.title;
    },
    /**
     * 校验token是否有效
     */
    async checkLogin() {
      const {
        err
      } = await isLogin();
      if (err) return;
    },
    noMovingUp() {
      var agent = navigator.userAgent.toLowerCase(); //  检测是否是ios
      var iLastTouch = null; //  缓存上一次tap的时间
      if (agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0) {
        document.body.addEventListener('touchend', function (event) {
          var iNow = new Date().getTime();
          iLastTouch = iLastTouch || iNow + 1; // 第一次时将iLastTouch设为当前时间+1
          var delta = iNow - iLastTouch;
          if (delta < 200 && delta > 0) {
            event.preventDefault();
            return false;
          }
          iLastTouch = iNow;
        }, false);
      }
    }
  }
};